import ImageWithBasePath from "@/components/image-with-base-path";
import HeaderNav from "../../../../components/header/headerNav";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../../../core/redux/store";
import { setMobileSidebar } from "../../../../core/redux/sidebarSlice";
import { Link } from "react-router";
import { all_routes } from "@/routes/all_routes";

import Slider, { type Settings } from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const HeroSection = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();

  const menuOpened = useSelector((state: RootState) => {
    const s = state.sidebar as any;
    // try known/possible property names, fallback to false
    return (s.menuOpened ?? s.mobileSidebar ?? s.isOpen ?? false) as boolean;
  });
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (menuOpened) document.body.classList.add("menu-opned");
    else document.body.classList.remove("menu-opned");
  }, [menuOpened]);

  const onMobileBtn = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(!menuOpened));
  };

  const onMenuClose = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(false));
  };
  // ...existing code...

  const settings: Settings = {
    dots: true,
     appendDots: (dots) => (
    <ul className="custom-dots">
      {dots}
    </ul>
  ),
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // adjust if needed
    arrows: false,
    fade: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* Start Hero Section */}
      <div className="hero-section-fifteen">
        <div className="hero-slider-fifteen">
          <Slider {...settings}>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/banner/banner-slide-1.jpg"
                alt="banner"
                className="img-fluid slide-img"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/banner/banner-slide-2.jpg"
                alt="banner"
                className="img-fluid slide-img"
              />
            </div>
            <div className="slide-item">
              <ImageWithBasePath
                src="assets/img/banner/banner-slide-3.jpg"
                alt="banner"
                className="img-fluid slide-img"
              />
            </div>
          </Slider>
        </div>
        {/* Header */}
        <header
          className={`header header-fifteen ${isScrolled ? "fixed" : ""}`}
        >
          <div className="container">
            <nav className="navbar navbar-expand-lg header-nav">
              <div className="navbar-header">
                <Link id="mobile_btn" to="#" onClick={onMobileBtn}>
                  <i className="fa-solid fa-bars" />
                </Link>
                <Link to={all_routes.home} className="navbar-brand logo">
                  <ImageWithBasePath
                    src="assets/img/logo-white-02.svg"
                    className="img-fluid white-logo"
                    alt="Logo"
                  />
                  <ImageWithBasePath
                    src="assets/img/logo-15.svg"
                    className="img-fluid normal-logo"
                    alt="Logo"
                  />
                </Link>
              </div>
              <div className="main-menu-wrapper">
                <div className="menu-header">
                  <Link to={all_routes.home} className="menu-logo">
                    <ImageWithBasePath
                      src="assets/img/logo-15.svg"
                      className="img-fluid"
                      alt="Logo"
                    />
                  </Link>
                  <button
                    type="button"
                    id="menu_close"
                    className="menu-close"
                    aria-label="close"
                    onClick={onMenuClose}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
                <HeaderNav />
                <div className="header-items">
                  {/* Item 1 */}
                  <div className="about-popup-item border-0 pb-0">
                    <h3 className="title">Contact Information</h3>
                    <div className="support-item mb-3">
                      <div className="avatar avatar-lg bg-primary rounded-circle">
                        <i className="isax isax-messages-3" />
                      </div>
                      <div>
                        <p className="title">General Inquiries</p>
                        <h3 className="link">info@example.com</h3>
                      </div>
                    </div>
                    <div className="support-item">
                      <div className="avatar avatar-lg bg-primary rounded-circle">
                        <i className="isax isax-call-calling" />
                      </div>
                      <div>
                        <p className="title">Emergency Cases</p>
                        <h3 className="link">+1 24565 89856</h3>
                      </div>
                    </div>
                  </div>
                  {/* Item 2 */}
                  <div className="about-popup-item border-0 pb-0">
                    <h3 className="title">Follow Us</h3>
                    <ul className="d-flex align-items-center gap-2 social-iyem">
                      <li>
                        <Link
                          to="#"
                          className="social-icon"
                          aria-label="Facebook"
                        >
                          <i className="fa-brands fa-facebook" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="social-icon"
                          aria-label="Twitter"
                        >
                          <i className="fa-brands fa-x-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="social-icon"
                          aria-label="Instagram"
                        >
                          <i className="fa-brands fa-instagram" />
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="social-icon"
                          aria-label="LinkedIn"
                        >
                          <i className="fa-brands fa-linkedin" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="header-items-button">
                    <Link
                      to={all_routes.login}
                      className="btn btn-primary"
                      aria-label="Sign In"
                    >
                      <i className="isax isax-lock-1 me-2" />
                      Sign
                    </Link>
                    <Link to={all_routes.login} className="btn btn-primary">
                      <i className="isax isax-lock-1 me-2" />
                      Sign In
                    </Link>
                    <Link
                      to={all_routes.register}
                      className="btn btn-secondary"
                    >
                      <i className="isax isax-user-tick4 me-2" />
                      Sign Up
                    </Link>
                  </div>
                </div>
              </div>
              <div className="nav header-navbar-rht">
                <Link to={all_routes.booking} className="btn btn-white">
                  Book A Consultation{" "}
                  <span className="icon">
                    <i className="isax isax-arrow-right-1" />
                  </span>
                </Link>
              </div>
            </nav>
          </div>
        </header>
        {/* Header End */}
        {/* Start Banner section */}
        <section className="banner-section-fifteen">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-8">
                <div
                  className="banner-content-fifteen wow fadeInUp"
                  data-wow-duration="2s"
                >
                  <h1 className="title">
                    Your Journey to{" "}
                    <span className="break-line">
                      {" "}
                      <span className="line">Mental</span> Wellness{" "}
                    </span>{" "}
                  </h1>
                  <p className="description">
                    Compassionate, evidence-based therapy and counseling
                    services to help you thrive. Connect with licensed
                    professionals who truly understand and care.
                  </p>
                  <div className="banner-btn">
                    <Link to="#" className="btn btn-white">
                      Begin Your Journey{" "}
                      <span className="icon">
                        <i className="isax isax-arrow-right-1" />
                      </span>
                    </Link>
                    <div className="banner-call">
                      <div className="call-icon">
                        <i className="isax isax-call-calling" />
                      </div>
                      <div>
                        <p className="title">Call Us</p>
                        <Link to="tel:+12456589856" className="link">
                          +1 24565 89856
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Banner section  */}
        <ImageWithBasePath
          src="assets/img/banner/overlay-img.png"
          alt="banner"
          className="img-fluid overlay-img"
        />
      </div>
      {/* End Hero Section */}
    </>
  );
};

export default HeroSection;
